import React, { useState } from "react";
import { Button, Popconfirm, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import ProductSelectModal from "features/LoyaltyPackage/presentation/pages/PackageForm/components/ProductSelectModal";

function ApplicableProductsSection({
  products = [],
  productIDs = [],
  onAddProducts,
  onRemoveProduct,
  disabled = false,
  error,
}) {
  const [modalVisible, setModalVisible] = useState(false);

  const handleConfirmSelect = (selectedItems) => {
    setModalVisible(false);
    if (!selectedItems || selectedItems.length === 0) return;
    onAddProducts(selectedItems);
  };

  const columns = [
    {
      title: "STT",
      key: "index",
      width: 60,
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "THÔNG TIN SẢN PHẨM",
      key: "name",
      render: (_, record) => (
        <div>
          <div style={{ color: "#2246dc", fontWeight: 500 }}>{record.code}</div>
          <div style={{ fontSize: "13px", color: "#262626" }}>{record.name}</div>
        </div>
      ),
    },
    {
      title: "THƯƠNG HIỆU",
      dataIndex: "brand",
      key: "brand",
      width: 140,
      render: (brand, record) => brand?.name || record?.brandName || "—",
    },
    {
      title: "NGÀNH HÀNG",
      dataIndex: "category",
      key: "category",
      width: 140,
      render: (cat, record) => cat?.name || record?.categoryName || "—",
    },
    {
      title: "TRẠNG THÁI",
      key: "status",
      width: 150,
      render: (_, record) => {
        const isActive = record.isActive !== false;
        return (
          <span
            style={{
              padding: "2px 10px",
              borderRadius: "4px",
              fontSize: "12px",
              color: isActive ? "#27a745" : "#e02020",
              border: `1px solid ${isActive ? "#c3e6cb" : "#f5c6cb"}`,
              backgroundColor: isActive ? "#f4fcf6" : "#fff5f5",
            }}
          >
            {isActive ? "Đang kinh doanh" : "Ngừng kinh doanh"}
          </span>
        );
      },
    },
    {
      title: "",
      key: "action",
      width: 60,
      align: "center",
      render: (_, record) =>
        disabled ? null : (
          <Popconfirm
            title="Xóa sản phẩm này khỏi danh sách áp dụng?"
            onConfirm={() => onRemoveProduct(record.id)}
            okText="Xóa"
            cancelText="Hủy"
          >
            <DeleteOutlined style={{ color: "#ff4d4f", cursor: "pointer", fontSize: "16px" }} />
          </Popconfirm>
        ),
    },
  ];

  return (
    <div
      style={{
        marginTop: "24px",
        padding: "20px",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        border: error ? "1.5px solid #ff4d4f" : "1px solid #e0e0e0",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
        <div>
          <div style={{ fontWeight: 600, fontSize: "15px", color: "#212529" }}>Sản phẩm áp dụng</div>
          <div style={{ fontSize: "12px", color: "#e02020", marginTop: "2px" }}>
            Banner chỉ hiển thị cho đại lý chưa từng mua bất kỳ sản phẩm nào trong danh sách dưới đây.
          </div>
          <div style={{ fontSize: "13px", color: "#595959", marginTop: "6px" }}>
            Tổng số sản phẩm áp dụng: <strong style={{ color: "#2246dc" }}>{products.length}</strong> sản phẩm
          </div>
        </div>

        {!disabled && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setModalVisible(true)}
            style={{
              backgroundColor: "#2246dc",
              borderColor: "#2246dc",
              borderRadius: "6px",
            }}
          >
            Thêm sản phẩm
          </Button>
        )}
      </div>

      {error && <div style={{ color: "#ff4d4f", fontSize: "12px", marginBottom: "8px" }}>{error}</div>}

      <Table
        dataSource={products}
        columns={columns}
        rowKey="id"
        pagination={products.length > 5 ? { pageSize: 5 } : false}
        size="small"
        locale={{
          emptyText: (
            <div style={{ padding: "24px 0", color: "#8c8c8c" }}>
              Chưa có sản phẩm áp dụng. Nhấn <strong>"+ Thêm sản phẩm"</strong> để chọn sản phẩm.
            </div>
          ),
        }}
      />

      {modalVisible && (
        <ProductSelectModal
          visible={modalVisible}
          selectedProductIds={productIDs}
          onCancel={() => setModalVisible(false)}
          onConfirm={handleConfirmSelect}
        />
      )}
    </div>
  );
}

export default React.memo(ApplicableProductsSection);
